<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="90"
    >
      <Form-item label="名称" prop="name">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.name"
          placeholder="请输入名称"
        />
      </Form-item>
      <Form-item label="图标类型" prop="iconType">
        <Select
          class="c-form__input"
          placeholder="请选择图标类型"
          clearable
          v-model="cForm.model.iconType"
        >
          <Option
            v-for="item in dicts.EntryIconType"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item
        v-if="cForm.model.iconType === 'Code'"
        label="内置图标"
        prop="iconCode"
      >
        <c-icon-select
          class="c-form__input"
          :value="cForm.model.iconCode"
          @change="
            value => {
              $set(cForm.model, 'iconCode', value);
            }
          "
        ></c-icon-select>
      </Form-item>
      <Form-item
        v-if="cForm.model.iconType === 'Id'"
        label="自定义图标"
        prop="iconId"
      >
        <c-uploader
          class="c-form__input"
          :key="`picture-${cForm.id}`"
          :default-file-ids="cForm.model.iconId"
          @change="
            value => {
              handleFormUploaderChange('iconId', value);
            }
          "
        />
      </Form-item>
      <Form-item label="点击事件" prop="event">
        <Select
          class="c-form__input"
          placeholder="请选择点击事件"
          clearable
          v-model="cForm.model.event"
        >
          <Option
            v-for="item in dicts.EntryEvent"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
      <Form-item
        v-if="cForm.model.event === 'OpenLink'"
        label="链接"
        prop="link"
      >
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.link"
          placeholder="请输入链接"
          search
          enter-button="选择链接"
          @on-search="$refs.linkSelect.show()"
        >
        </Input>
        <c-link-select
          ref="linkSelect"
          @select="
            value => {
              cForm.model.link = value;
            }
          "
        ></c-link-select>
      </Form-item>
      <Form-item
        v-if="cForm.model.event === 'OpenCategory'"
        label="商品分类"
        prop="link"
      >
        <c-school-category-select
          class="c-form__input"
          select-parent
          alias="products"
          v-model="cForm.model.categoryId"
          @change="
            value => {
              $set(cForm.model, 'categoryId', value);
            }
          "
        ></c-school-category-select>
      </Form-item>
      <Form-item
        v-if="cForm.model.event === 'FollowOa'"
        label="公众号二维码"
        prop="qrCodePictureId"
      >
        <c-uploader
          class="c-form__input"
          :key="`qrcode-picture-${cForm.id}`"
          :default-file-ids="cForm.model.qrCodePictureId"
          @change="
            value => {
              handleFormUploaderChange('qrCodePictureId', value);
            }
          "
        />
      </Form-item>
      <Form-item label="状态" prop="status">
        <Select
          class="c-form__input"
          placeholder="请选择状态"
          clearable
          v-model="cForm.model.status"
        >
          <Option
            v-for="item in dicts.PublishStatus"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          >
            {{ item.label }}
          </Option>
        </Select>
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "entries";

@Component({
  mixins: [FormMixin]
})
export default class ListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          name: [
            {
              required: true,
              message: "名称不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {
      status: 1,
      iconType: "Code",
      event: "OpenLink"
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;
        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
